// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactSnapshot_container__1JUim","profilePic":"ContactSnapshot_profilePic__3dO9m","items":"ContactSnapshot_items__3gXlo","spacer":"ContactSnapshot_spacer__3Vao3"};